import React, { useState, useEffect } from "react";
import { StocksGroupImage } from "../../../../assets/images";
import AddEditStockGroupModal from "../../../../components/ClientSettings/StockManager/StockGroups/AddEditStockGroupModal";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import { RootState } from "../../../../redux/rootReducers";
import { connect } from "react-redux";
import {
  AddStockGroupPayloadType,
  GetAllStocksGroupPayloadType,
  UpdateStockGroupPayloadType,
} from "../../../../commonTypes/clientSettingsTypes";
import {
  addStockGrouopAction,
  getAllTypesStocksGroupAction,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetStockGroupActionList,
  resetStockGroupsListTotal,
  updateStockGroupAction,
} from "../../../../redux/clientSettings";
import { AllGroupStockListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { STOCK_GROUP_MANAGER_HEADERS } from "../../../../constant/tableHeadersConstants/clientSettingsconstants/stockGroupManagerHeader";
import { resetSession } from "../../../../redux/auth";
import toast, { Toaster } from "react-hot-toast";
import { SearchIcon } from "../../../../components/Icon";
import StockTables from "../../../../components/ClientSettings/StockManager/StockGroups/StockGroupManagerTable/StockTables";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import ScrollToTop from "../../../../components/commons/ScrollToTop";
import InfiniteLoader from "../../../../components/commons/InfiniteLoader/InfiniteLoader";

type AppProps = {
  history?: any;
  token: string | null;
  success: number | null;
  statusCode: number | null;
  error: string | null;
  fetching: boolean;
  groupStockList: [] | AllGroupStockListType[];
  dispatchGetAllStockGroupsListAction: (
    data: GetAllStocksGroupPayloadType
  ) => void;
  dispatchAddStockGroupAction: (data: AddStockGroupPayloadType) => void;
  dispatchResetClientSettingsSuccessAction: () => void;
  dispatchResetSession: () => void;
  dispatchResetClientSettingsError: () => void;
  StockGroupsListTotal: string | number;
  dispatchUpdateGroupStockAction: (data: UpdateStockGroupPayloadType) => void;
  dispatchResetStockGroupActionList:()=> void;
  dispatchResetStockGroupActionTotal:()=> void;
  dispatchResetStockGroupsListTotal:()=> void;
};

const StockGroupsList = ({
  history,
  token,
  success,
  error,
  fetching,
  groupStockList,
  statusCode,
  dispatchGetAllStockGroupsListAction,
  dispatchAddStockGroupAction,
  dispatchResetClientSettingsSuccessAction,
  dispatchResetSession,
  dispatchResetClientSettingsError,
  StockGroupsListTotal,
  dispatchUpdateGroupStockAction,
  dispatchResetStockGroupActionList,
  dispatchResetStockGroupActionTotal,
  dispatchResetStockGroupsListTotal
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const company_name = history?.location?.state?.company_name;
  const [showStockGroupModal, setShowStockGroupModal] =
    useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editStockGroupDetailsData, setEditStockGroupDetailsData] = useState<any>({});
  const [searchData, setSearchData] = useState("");
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data,setData]= useState<[] | AllGroupStockListType[]>([])

  //====================User Management=============================
  const [isAddStockGroupPresent, setIsAddStockGroupPresent] = useMenuCheck()
  const [isEditStockGroupPresent, setisEditStockGroupPresent] = useMenuCheck()
  //=================================================================

  useEffect(() => {
    dispatchResetStockGroupActionTotal();
    dispatchResetStockGroupActionList();
    dispatchResetClientSettingsError();
    dispatchResetClientSettingsSuccessAction();
    dispatchResetStockGroupsListTotal();
    setIsAddStockGroupPresent("Add Stock Group","menu")
    setisEditStockGroupPresent("Edit Stock Group","menu")
    setEditStockGroupDetailsData({});
     //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (token && client_code) {
      let finalData: GetAllStocksGroupPayloadType = {
        token,
        client_code,
        limit,
        offset,
        search_term: searchData,
      };
      if (offset <+StockGroupsListTotal) {
          dispatchGetAllStockGroupsListAction(finalData);
        }
      else if(offset===0 && StockGroupsListTotal===''){
        dispatchGetAllStockGroupsListAction(finalData);
      }
    }
     //eslint-disable-next-line
  },[offset])

useEffect(() => {
   if (groupStockList?.length === 0) {
         setData(groupStockList)
        }
           if (offset > 0) {
          setData((prv:any)=>[...prv,...groupStockList])
        }
        else {
          setData(groupStockList)
        }
     //eslint-disable-next-line
  }, [groupStockList]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        fetchNewData();
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
   //eslint-disable-next-line
  }, [searchData]);

  const toggleAddStockGroupModal = () => {
    setShowStockGroupModal(!showStockGroupModal);
  };
  const handleAddStockGroupDetails = (data: AddStockGroupPayloadType) => {
    if (client_code && token) {
      let finalData = {
        client_code,
        token,
        stock_group_name: data?.stock_group_name,
        is_quantities_enabled: data?.is_quantities_enabled,
        parent_group_id: data?.parent_group_id,
      };
      dispatchAddStockGroupAction(finalData);
      setShowStockGroupModal(false);
      handleSuccessMessage("create_stock_group");
      setSearchData("")
    }
  };

  const handleSendStockGroupDetailsToModal = (data: AddStockGroupPayloadType) => {
    setIsEdit(true);
    setEditStockGroupDetailsData(data);
    setShowStockGroupModal(true);
  };
  const handleEditStockGroupDetails = (data: UpdateStockGroupPayloadType) => {
    let finalData = {
      client_code,
      token,
      stock_group_name: data?.stock_group_name,
      is_quantities_enabled: data?.is_quantities_enabled,
      parent_group_id: data?.parent_group_id,
      stock_group_id: data?.stock_group_id,
    };

    if (token && client_code) {
      dispatchUpdateGroupStockAction(finalData);
      setIsEdit(false);
    }
    setShowStockGroupModal(false);
    handleSuccessMessage("update_stock_group");
    setSearchData("")
  };

  const handleResetEditData = () => {
    setIsEdit(false);
    setEditStockGroupDetailsData({});
  };

  const fetchNewData = () => {
    if (token && client_code) {
      let finalData = {
        token,
        client_code,
        search_term: searchData,
        limit,
        offset
      };
       if (offset === 0) {
        // setOffset(0)
         dispatchGetAllStockGroupsListAction(finalData);
      }
      else {
        setOffset(0);
      }
     
    }
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit,
        token,
        client_code,
      };
      dispatchGetAllStockGroupsListAction(finalData);
    }
  };

  const onScroll = () => {
        const scrollTop = document.documentElement.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        
      if (Math.ceil( 75/100*scrollHeight)<=scrollTop + clientHeight) {
        if (groupStockList?.length>0) {
          setOffset(offset + limit)
        }
      }
  }
  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
     //eslint-disable-next-line
  }, [groupStockList]);


  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      dispatchResetClientSettingsSuccessAction();
      toast.success(successMessage, {
        duration: 2000,
      });
      
      if (token && client_code ) {
        if (offset === 0) {
               let finalData = { token, client_code,offset:0,limit };
        dispatchGetAllStockGroupsListAction(finalData);
      }
      }
      
    }
    return false;
  };

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "update_stock_group":
        return setSuccessMessage("Stock Group Updated Successfully!");
      case "create_stock_group":
        return setSuccessMessage("Stock Group Added Successfully!");
      default:
        return setSuccessMessage("");
    }
  };

  useEffect(() => {
    if (offset === 0) {
        window.scrollTo(0, 0);
    }
    else {
      window.scrollTo(0, 0);
      setOffset(0)
    }
     //eslint-disable-next-line
  }, [success])
  
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader
            title="Stocks Group"
            company_name={company_name}
            client_code={client_code}
          />
        </div>
        <div className="col-md-6 text-right">
          {!!groupStockList?.length && isAddStockGroupPresent && (
            <button onClick={toggleAddStockGroupModal} className="btn btn-primary">
              + Add Stock Group
            </button>
          )}
        </div>
        <div className="col-md-12 mt-4">
          <div className="new-table-card">
            <div className="header">
            <div className="left-header">
                <div className="heading">Stock Group List</div>
                {!fetching && <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${StockGroupsListTotal ? StockGroupsListTotal : 0
                  } entries found`}</div>}
              </div>
              <div className="col-md-4 right-header" style={{marginLeft:"70px"}}>
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchData}
                />
              </div>
            </div>

            { groupStockList?.length ? (
              <>
              <StockTables
                data={data}
                fetching={fetching}
                headers={STOCK_GROUP_MANAGER_HEADERS}
                isEditStockGroupPresent={isEditStockGroupPresent}
                handleEditStockGroupDetails={handleSendStockGroupDetailsToModal}
                />
               <div style={{display:fetching?"none":"inline"}}><ScrollToTop/></div>
               {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                </>
            ) : (
             !fetching?<EmptyListPage 
                title="No Stocks Group Found!"
                text="Add a stock group to see it here in the list!"
                image={StocksGroupImage}
                imageWidth="30%"
                showAddButton
                buttonTitle="+ Add Stock Groups"
                onButtonClick={toggleAddStockGroupModal}
                /> : ""
                    
            )
          }
          </div>
        </div>
        {showStockGroupModal && (
          <AddEditStockGroupModal
            isOpen={showStockGroupModal}
            client_code={client_code}
            handleAddStockGroupDetails={handleAddStockGroupDetails}
            editStockGroupDetailsData={editStockGroupDetailsData}
            isEdit={isEdit}
            handleEditStockGroupDetails={handleEditStockGroupDetails}
            handleResetEditData={handleResetEditData}
            toggleAddStockGroupModals={toggleAddStockGroupModal}
          />
        )}
        {handleErrorModal()}
        <Toaster />
        {fetching&& offset===0&& <Loader /> }
      </div>
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  error: state.clientSettings.error,
  groupStockList: state.clientSettings.groupStockList,
  statusCode: state.clientSettings.statusCode,
  StockGroupsListTotal: state.clientSettings.groupStockListTotal,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetClientSettingsSuccessAction: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchGetAllStockGroupsListAction: (data: GetAllStocksGroupPayloadType) =>
    dispatch(getAllTypesStocksGroupAction(data)),
  dispatchAddStockGroupAction: (data: AddStockGroupPayloadType) =>
    dispatch(addStockGrouopAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchUpdateGroupStockAction: (data: UpdateStockGroupPayloadType) =>
    dispatch(updateStockGroupAction(data)),
  dispatchResetStockGroupActionList: () => dispatch(resetStockGroupActionList()),
  dispatchResetStockGroupActionTotal: () => dispatch(resetStockGroupsListTotal()),
  dispatchResetStockGroupsListTotal: () => dispatch(resetStockGroupsListTotal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(StockGroupsList);
